// Func = limiting Scope for this file
(function(){
	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {
			$('#header').addClass('scroll1');
			//$('.booking-holder').addClass('initiate');
			setTimeout(function(){
				$('#header .booking-holder').fadeOut();
			}, 700);

		} else {
			$('#header').removeClass('scroll1');
			//$('.booking-holder').removeClass('initiate');
		}
	}

	//animations below
	const animateHTML = function () {
		let elems,
			windowHeight;
		let init = function () {
			elems = document.getElementsByClassName('standby');
			windowHeight = window.innerHeight;
			addEventHandlers();
		};
		let addEventHandlers = function () {
			window.addEventListener('scroll', checkPosition);
			window.addEventListener('resize', init);
		};
		let checkPosition = function () {
			for (let i = 0; i < elems.length; i++) {
				let posFromTop = elems[i].getBoundingClientRect().top;
				if (posFromTop - windowHeight <= 0) {
					elems[i].className = elems[i].className.replace('standby', 'initiate')
				}
			}
		};
		return {
			init: init
		}
	};
	animateHTML().init();
	//end animations

	if(!$('body').hasClass('landing-page-countdown') && !$('body').hasClass('landing-page-form')) {
		
	}
	$('.booking-trig-js').click(function(event){
		//$('.booking-holder').removeClass('initiate').addClass('open');
		$('#header .booking-holder').fadeIn();
	});

	$('.close-booking-js').click(function(event){
		$('#header .booking-holder').fadeOut();
	});


	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$( ".mini-booking-form" ).submit(function(event){
			var months = new Array();
			for(var i=0;i<=11;i++)
				months[i] = i+1;

			if( $( this ).find( "._fromDate" ).val() == "" ){

				//date_m_d_yy
				var title = $( this ).parent().parent().find( "h2" );

				var from_date = new Date( );

				/* FROM DATE */
				if( $( title ).hasClass( "advance-90" ) ){
					from_date.setDate( from_date.getDate() + 90 );
				}else if( $( title ).hasClass( "minimumstay-3" ) ){
					from_date.setDate( from_date.getDate() + 3 );
				}else{
					from_date.setDate( from_date.getDate() + 1 );
				}

				var month = (months[from_date.getMonth()]) < 10 ? "0" + (months[from_date.getMonth()]) : (months[from_date.getMonth()]);
				var day = from_date.getDate() < 10 ? "0" + from_date.getDate() : from_date.getDate();

				var date_format = month + "/" + day + "/" + from_date.getFullYear();

				$( this ).find( "._fromDate" ).val( date_format );
				$( this ).find( "input[name=fromDate]" ).val( from_date.getFullYear()+"-"+month+"-"+day );

				/* TO DATE */
				var to_date = new Date(from_date.getFullYear(), from_date.getMonth(), from_date.getDate());
				to_date.setDate( to_date.getDate() + 3 );

				var month = (months[to_date.getMonth()]) < 10 ? "0" + (months[to_date.getMonth()]) : (months[to_date.getMonth()]);

				var day = to_date.getDate() < 10 ? "0" + to_date.getDate() : to_date.getDate();

				var to_date_format = month + "/" + day + "/" + to_date.getFullYear();
				$( this ).find( "input[name=toDate]" ).val( to_date.getFullYear()+"-"+month+"-"+day );
				$( this ).find( "._toDate" ).val( to_date_format );

				fillStartDateDropdowns( date_format );
				fillEndDateDropdowns( to_date_format );

			}
			return true;
		} );

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		function fillStartDateDropdowns(date_m_d_yy) {

			var strFilled;
			strFilled = date_m_d_yy.split("/");

			$(".startmonth").val((strFilled[0]-1)+strFilled[2]);  //put values
			$(".startday").val(strFilled[1]);
		}
		function fillEndDateDropdowns(date_m_d_yy) {

			var strFilled;
			strFilled = date_m_d_yy.split("/");

			$(".endmonth").val((strFilled[0]-1)+strFilled[2]);   //put values
			$(".endday").val(strFilled[1]);
		}

		//Check in and check out datepicker for booking engine
		let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+0D",
			beforeShow: function (input, inst) {
				setTimeout(function () {
					let offsets_booking = document.querySelector(`.booking-holder`).offsetTop;
					var top = offsets_booking - 331;
					var offsets_input = $("#CheckIn").offset();
					inst.dpDiv.css({
						top: top,
						left: offsets_input.left,
					});
				}, 0);
			},
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let dayIn  = getDate.getDate();
				let monthIn = getDate.getMonth();
				let weekIn = $.datepicker.formatDate('D', getDate);
				let newDate = new Date(getDate.getTime());
				$( "#arrivalDate .date-num" ).html(dayIn);
				$( "#arrivalDate .date-day" ).html(weekIn);
				$( "#arrivalDate .date-month" ).html(monthNames[monthIn]);
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
				let dayOut  = newDate.getDate();
				let monthOut = newDate.getMonth();
				let weekOut = $.datepicker.formatDate('D', newDate);
				$( "#departureDate .date-num" ).html(dayOut);
				$( "#departureDate .date-day" ).html(weekOut);
				$( "#departureDate .date-month" ).html(monthNames[monthOut]);

				fillStartDateDropdowns($(this).val());
				fillEndDateDropdowns($('#CheckOut').val());
			}
		});

		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			minDate: "+1D",
			numberOfMonths: 1,
			beforeShow: function (input, inst) {
				setTimeout(function () {
					let offsets_booking = document.querySelector(`.booking-holder`).offsetTop;
					var top = offsets_booking - 331;
					var offsets_input = $("#CheckOut").offset();
					inst.dpDiv.css({
						top: top,
						left: offsets_input.left,
					});
				}, 0);
			},
			onSelect: function( selectedDate ) {
				$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				let getDate = $(this).datepicker('getDate');
				let dayOut  = getDate.getDate();
				let weekOut = $.datepicker.formatDate('D', getDate);
				let monthOut = getDate.getMonth();
				$( "#departureDate .date-num" ).html(dayOut);
				$( "#departureDate .date-day" ).html(weekOut);
				$( "#departureDate .date-month" ).html(monthNames[monthOut]);

				fillEndDateDropdowns($(this).val());
			}
		});
		$( "#CheckInD" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+0D",
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let dayIn  = getDate.getDate();
				let monthIn = getDate.getMonth();
				let weekIn = $.datepicker.formatDate('D', getDate);
				let newDate = new Date(getDate.getTime());
				$( "#arrivalDate .date-num" ).html(dayIn);
				$( "#arrivalDate .date-day" ).html(weekIn);
				$( "#arrivalDate .date-month" ).html(monthNames[monthIn]);
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
				let dayOut  = newDate.getDate();
				let monthOut = newDate.getMonth();
				let weekOut = $.datepicker.formatDate('D', newDate);
				$( "#departureDate .date-num" ).html(dayOut);
				$( "#departureDate .date-day" ).html(weekOut);
				$( "#departureDate .date-month" ).html(monthNames[monthOut]);

				fillStartDateDropdowns($(this).val());
				fillEndDateDropdowns($('#CheckOut').val());
			}
		});

		$( "#CheckOutD" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			minDate: "+1D",
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				let getDate = $(this).datepicker('getDate');
				let dayOut  = getDate.getDate();
				let weekOut = $.datepicker.formatDate('D', getDate);
				let monthOut = getDate.getMonth();
				$( "#departureDate .date-num" ).html(dayOut);
				$( "#departureDate .date-day" ).html(weekOut);
				$( "#departureDate .date-month" ).html(monthNames[monthOut]);

				fillEndDateDropdowns($(this).val());
			}
		});
		$("#landing-CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+0D",
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#landing-CheckOut").datepicker("setDate", newDate);
				$("#landing-CheckOut").datepicker("option", "minDate", selectedDate);

				fillStartDateDropdowns($(this).val());
				fillEndDateDropdowns($('#landing-CheckOut').val());
			}
		});

		$("#landing-CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			minDate: "+0D",
			numberOfMonths: 1,
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				fillEndDateDropdowns($(this).val());
			}
		});


		/* setTimeout(function(){
			$('#home #header .booking-holder').fadeIn();
		}, 750); */

		//$('.booking-holder').addClass('open');


		// Map: Return to previous page button. Change body id to match map template's name.
		$('body#map-category #content').prepend('<a class="btn btn--box return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$('body#map-category #content').prepend('<a class="btn btn--box ada-map-btn" href="/location/ada-map">View Accessibility Map</a>');

		$('.booking-acom-btn').click(function() {
			event.preventDefault();
			$('#header .booking-holder').removeClass('initiate').fadeIn();
		});


		////tabs sections
		const tabLinks = document.querySelectorAll('ul.tabs-menu li a');

		for (let i = 0; i < tabLinks.length; i++) {
			tabLinks[i].onclick = function() {
				let target = this.getAttribute('href').replace('#', '');
				let sections = document.querySelectorAll('div.tab-content');
				for(let j=0; j < sections.length; j++) {
					sections[j].style.display = 'none';
				}
				document.getElementById(target).style.display = 'flex';
				for(let k=0; k < tabLinks.length; k++) {
					tabLinks[k].removeAttribute('class');
				}
				this.setAttribute('class', 'active');
				return false;
			}
		}

		//$('#footer .signup-btn').addClass('btn btn--arrow').wrapInner('<span class="btn--arrow__arrow"></span>');

		$('.show-content').click(function() {
			event.preventDefault();
			$(this).parents('.each-item').children('.each-item__overlay').fadeIn();
		});

		$('.closemore').click(function() {
			event.preventDefault();
			$(this).parent().fadeOut();
		});

		setTimeout(function(){
			$('#home .title--uvp').addClass('initiate');
		}, 800);

		$(".sym-slides-specials").slick({
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 7000,
			speed: 500,
			fade: false,
			accessibility: true,
			pauseOnHover: false,
			mobileFirst: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
			]
		});


		$(".offers-datepicker").datepicker({
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+0D",
			dateFormat: 'mm/dd/yy'
		});

		$( ".offers-datepicker.advance-90._fromDate" ).datepicker( "destroy" );
		$( ".offers-datepicker.advance-90._fromDate" ).removeClass("hasDatepicker").removeAttr('id');
		$( ".offers-datepicker.advance-90._fromDate" ).datepicker({
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+90D",
			dateFormat: 'mm/dd/yy'
		});
		$( ".offers-datepicker.advance-90._toDate" ).datepicker( "destroy" );
		$( ".offers-datepicker.advance-90._toDate" ).removeClass("hasDatepicker").removeAttr('id');
		$( ".offers-datepicker.advance-90._toDate" ).datepicker({
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+93D",
			dateFormat: 'mm/dd/yy'
		});

		$( ".offers-datepicker.minimumstay-3._fromDate" ).datepicker( "destroy" );
		$( ".offers-datepicker.minimumstay-3._fromDate" ).removeClass("hasDatepicker").removeAttr('id');
		$( ".offers-datepicker.minimumstay-3._fromDate" ).datepicker({
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+3D",
			dateFormat: 'mm/dd/yy'
		});
		$( ".offers-datepicker.minimumstay-3._toDate" ).datepicker( "destroy" );
		$( ".offers-datepicker.minimumstay-3._toDate" ).removeClass("hasDatepicker").removeAttr('id');
		$( ".offers-datepicker.minimumstay-3._toDate" ).datepicker({
			changeMonth: true,
			numberOfMonths: 1,
			minDate: "+6D",
			dateFormat: 'mm/dd/yy'
		});

		//Specials add/remove box-shadow to "active" offer from navigation
		//var hash = location.hash.replace("#","");
		//if (window.location.href.indexOf(hash)) {
		//	setTimeout(function(){
		//		alert('hey #');
		//	}, 400);
        //
		//}

		//Weddings form scroll
		$('a[href="#formRFPWeddings"]').click(function(){
			$([document.documentElement, document.body]).animate({
				scrollTop: $("#formRFPWeddings").offset().top - 175
			}, 1500);
		});

		$('a[href="#formRFP"]').click(function(){
			$([document.documentElement, document.body]).animate({
				scrollTop: $("#formRFP").offset().top - 175
			}, 1500);
		});


		/*MOBILE MENU NAV
		 ****************************************************************/

		//Open Navigation
		$('#menu-btn').click(function(event) {
			$('html').addClass('hide-overflow');
			$('.navigation').addClass('open');
			$('.navigation').stop().animate({left:'0px'},{duration:300});
			if($('.navigation ul li a').hasClass('.item-open')){
				$(".item-open").get(0).scrollIntoView(false);
			}
		});

		$('.close-menu').click(function(event) {
			event.preventDefault();
			$('html').removeClass('hide-overflow');
			$('.navigation').removeClass('open');
			$('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
		});

		//SUBNAVIGATION

		// Open active sub-nav on load
		$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
		$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
		$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');

		//Toggle open/close on tap
		$('.navigation li a').off('click').on('click', function(event) {
			if ( $(this).parent().children(".sub-sub-menu").length > 0 ) {

				event.preventDefault();

				if ($(this).next().hasClass('menu-open')) {
					$(this).closest('.inner').removeClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$(this).next().slideUp(300, function(){
						if($('.navigation ul li a').hasClass('active')){
							$(".item-open").get(0).scrollIntoView(false);
						}
					}).removeClass('menu-open');
				} else {
					$(this).closest('.inner').addClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
					$(this).next().addClass('menu-open').slideDown(300, function(){
						if($('.navigation ul li a').hasClass('active')){
							$(".item-open").get(0).scrollIntoView(false);
						}
					});
				}
			}
		});

	//aria-label addet to Meeting item of the main nav
	$('#privary-navigation li.primary-nav-5 a').each(function() {
		$(this).attr('aria-label', 'IC Miami Meeting');
	});

	//aria-label addet to Meeting item of the main nav
	$('.inner ul li.primary-nav-9 a').each(function() {
		$(this).attr('aria-label', 'IC Miami Meeting');
	});

	});
	if (location.hash) {
		if (location.hash.search('offer') > 0){
			$(location.hash).addClass('active');
		}
		setTimeout(function() {
			window.scrollTo(0, 0);
		}, 1);
		setTimeout(function() {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $(location.hash).offset().top - 200
				},
				1
			);
		}, 300);
	}

	if($('.offers').length > 0){
		$('a[href*="#offer"]').click(function(e){
			var offer_block = $(this).attr('href').replace("/offers", "");
			$('.offers-container .each-item').removeClass('active');
			$(offer_block).addClass('active');
		});
	}

	$("#privary-navigation a[href*='meetings#formRFP'], #privary-navigation a[href*='weddings#formRFPWeddings']").click(function() {
		$([document.documentElement, document.body]).animate(
			{
				scrollTop: $(location.hash).offset().top - 200
			},
			1
		);
	});
	$(".scroll-to").click(function (e) {
		e.preventDefault();
		var scroll_section = $(this).attr('href');
		$([document.documentElement, document.body]).animate(
			{
				scrollTop: $(scroll_section).offset().top - 200
			},
			1
		);
	});

	if ($('#email-signup #_yes-signup-form').length > 0) {
		$('#email-signup #_yes-signup-form').addClass('required');
	}
	$(window).on('load', function() {

	});

}());